import { useMemo } from "react";
import {
  ID_DOCUMENT_VERIFICATION_EXCEPTIONS,
  ID_DOCUMENT_VERIFICATION_RETRIABLE_HTTP_STATUS_CODES,
  idDocumentVerificationExceptionMatches,
} from "../../../config";

export const useDocumentIdPictureStepErrors = ({
  idDocumentVerification,
  isUploadMode,
  hasSelectedPicture,
  selectedBase64,
}) => {
  const exception = idDocumentVerification?.error?.payload?.data?.exception;
  const errorActionType = idDocumentVerification?.error?.type;
  const errorStatus =
    idDocumentVerification?.error?.requestStatus ??
    idDocumentVerification?.error?.payload?.status ??
    null;

  const invalidPhotoError = idDocumentVerificationExceptionMatches(
    exception,
    ID_DOCUMENT_VERIFICATION_EXCEPTIONS.INVALID_DOCUMENT_PHOTO
  );

  const processExpiredError = idDocumentVerificationExceptionMatches(
    exception,
    ID_DOCUMENT_VERIFICATION_EXCEPTIONS.PROCESS_EXPIRED
  );

  const hasError = !!idDocumentVerification?.error;

  const genericError = hasError && !invalidPhotoError && !processExpiredError;

  const retriableVerifyError =
    errorActionType ===
      "REQUEST_POST_ID_DOCUMENT_VERIFICATION_VERIFY_REJECTED" &&
    ID_DOCUMENT_VERIFICATION_RETRIABLE_HTTP_STATUS_CODES.includes(errorStatus);

  const continueDisabled = useMemo(() => {
    if (hasError) return true;
    if (isUploadMode) {
      return !hasSelectedPicture || !selectedBase64;
    }
    return !selectedBase64;
  }, [hasError, hasSelectedPicture, isUploadMode, selectedBase64]);

  return {
    invalidPhotoError,
    processExpiredError,
    genericError,
    retriableVerifyError,
    hasError,
    continueDisabled,
  };
};
